function createResumeRecovery({ isVisible, needsConnection, renew, onLongAbsence = () => {}, onResume = () => {}, onHide = () => {}, readHiddenAt = () => null, writeHiddenAt = () => {}, canRenewAfterAbsence = () => true, now = Date.now }) {
  const saved = readHiddenAt();
  let hiddenAt = Number.isFinite(saved) ? saved : null;
  let lastRenewedAt = -Infinity;
  return event => {
    if (event?.type === 'pagehide' || !isVisible()) {
      if (hiddenAt === null) { hiddenAt = now(); writeHiddenAt(hiddenAt); onHide(); }
      return;
    }
    const away = hiddenAt === null ? 0 : now() - hiddenAt;
    hiddenAt = null;
    writeHiddenAt(null);
    if (away > 0) onResume({awayMs: away});
    if (away >= 3 * 60 * 1000) onLongAbsence();
    if ((needsConnection() || ((away >= 15000 || event?.persisted) && canRenewAfterAbsence())) && now() - lastRenewedAt >= 1000) {
      lastRenewedAt = now();
      renew({reason: away >= 15000 ? 'resume-suspension' : event?.persisted ? 'resume-bfcache' : 'resume-unhealthy', awayMs: away});
    }
  };
}
module.exports = { createResumeRecovery };
